import { render, staticRenderFns } from "./WebStoreLoyaltyCard.vue?vue&type=template&id=2568e1f6&"
import script from "./WebStoreLoyaltyCard.vue?vue&type=script&lang=js&"
export * from "./WebStoreLoyaltyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports